<template>
    <div class="job-container">
        <card>
            <b-row>
                <b-col>
                    <base-input label="Job name" placeholder="Job name" v-model="jobData.name"></base-input>
                </b-col>
                <b-col cols="6"></b-col>
                <b-col>
                    <b-dropdown text="Job actions" variant="success" class="m-2">
                        <b-dropdown-item @click="saveJob()">Save Job</b-dropdown-item>
                        <b-dropdown-item :disabled="jobData.id===null" @click="startJob()">Start job</b-dropdown-item>
                        <b-dropdown-item @click="saveAndStartJob()">Save and start job</b-dropdown-item>
                        <b-dropdown-item :disabled="jobData.id===null" @click="scheduleJob()">Schedule job</b-dropdown-item>
                        <b-dropdown-item @click="showImportDialog=true">Import job</b-dropdown-item>
                        <b-dropdown-item @click="showExportDialog=true">Export job</b-dropdown-item>
                        <b-dropdown-item @click="showDeleteDialog=true">Delete job</b-dropdown-item>
                    </b-dropdown>
                    <base-button icon type="info" class="btn btn-info" @click="switchJob()">
                        <span class="btn-inner--icon">
                            <i :class="{'ni ni-fat-add':!showJob, 'ni ni-fat-delete':showJob}"/>
                        </span>
                    </base-button>
                </b-col>
            </b-row>
        </card>
        <template v-if="showJob">
            <card>
                <b-row>
                    <b-col>
                        <h4>Operations</h4>
                        <base-button icon type="info" @click="addOperation()">
                            <span class="btn-inner--icon">
                                <i class="ni ni-fat-add"/>
                            </span>
                        </base-button>
                    </b-col>
                </b-row>
            </card>
            <card v-if="jobData.operations.length===0">
                <h3>No operations</h3>
            </card>
            <card v-else v-for="(operation,index) in jobData.operations" v-bind:key="'col'+index">
                <b-col>
                    <base-button icon type="info" @click="changeOperationIndex(index,index-1)">
                        <span class="btn-inner--icon">
                            <i class="ni ni-bold-up"/>
                        </span>
                    </base-button>
                    <base-button icon type="info" @click="deleteOperation(index)">
                        <span class="btn-inner--icon">
                            <i class="ni ni-fat-remove"/>
                        </span>
                    </base-button>
                    <base-button icon type="info" @click="changeOperationIndex(index,index+1)">
                        <span class="btn-inner--icon">
                            <i class="ni ni-bold-down"/>
                        </span>
                    </base-button>
                </b-col>
                <operation v-if="parsers!==null && requestHandlers!==null && proxies!==null" v-bind:key="index" :ref="'operation_'+index" :operation="operation" :parsers="parsers" :requestHandlers="requestHandlers" :proxies="proxies"/>
                <b-col v-else>
                    <p>Loading...</p>
                </b-col>
            </card>
        </template>
        <modal :show.sync="showDeleteDialog">
            <h4 slot="header">Delete job ?</h4>
            <p>You are about to delete job named "{{jobData.name}}". Do you want to continue ?</p>
            <template slot="footer">
                <base-button type="link" class="ml-auto" @click="showDeleteDialog = false">No, do not delete job</base-button>
                <base-button type="danger" @click="deleteJob()">Yes, delete job</base-button>
            </template>
        </modal>
        <modal :show.sync="showImportDialog">
            <h4 slot="header">Import job</h4>
            <p>Paste the job data you copied and press "Import" to import job.</p>
            <p><b>WARNING</b> this will override current job data! (but will not save changes to database)</p>
            <b-form-textarea v-model="importData" />
            <template slot="footer">
                <base-button type="danger" @click="showImportDialog=false">Cancel</base-button>
                <base-button type="success" @click="importJob()">Import</base-button>
            </template>
        </modal>
        <modal :show.sync="showExportDialog" :resizable="true" :adaptive="true" height="80%" width="80%">
            <h4 slot="header">Export job</h4>
            <p>Job data below can be used to export this job.</p>
            <b-form-textarea plaintext :value="exportJob()" />
            <template slot="footer">
                <base-button type="primary" @click="showExportDialog=false">OK</base-button>
            </template>
        </modal>
    </div>
</template>

<script>
import Operation from './Operation'
import Repository from '@/repositories/RepositoryFactory'

const JobRepository = Repository.get('job')
const JobSchedulerRepository = Repository.get('job_scheduler')

const ParserRepository = Repository.get('parser')
const RequestHandlerRepository = Repository.get('request_handler')
const ProxyRepository = Repository.get('proxy')

export default {
    name:'job',
    components:{
        Operation,
    },
    props:{
        jobData:Object,
    },
    emits: ['update:tag-list'],
    data(){
        return {
            showJob:true,
            tagList: new Set(),
            

            showDeleteDialog:false,
            showImportDialog:false,
            showExportDialog:false,

            importData:'',

            parsers:null,
            requestHandlers:null,
            proxies:null,
        }
    },
    created(){
        this.getParsers();
        this.getRequestHandlers();
        this.getProxies();
    },
    methods: {
        modifyTagList(){
            this.tagList.clear();
            for(var i in this.jobData.operations){
                this.tagList.add(this.requestHandlers[this.jobData.operations[i].request_handler])
                this.tagList.add(this.parsers[this.jobData.operations[i].parser])

                if( this.jobData.operations[i].loop_operation){
                    this.tagList.add("loop_operation")
                }

                for (var j in this.jobData.operations[i].actions)
                this.tagList.add(this.jobData.operations[i].actions[j].action)
            }},
        getParsers(){
            ParserRepository.get().then((response)=> {
                var parsers={};

                for(var i in response.data){
                    var parser=response.data[i];
                    parsers[parser.id]=parser.name;
                }
                this.parsers=parsers;
            });

        },
        getRequestHandlers(){
            RequestHandlerRepository.get().then((response)=> {
                var requestHandlers={null:"No handler"};

                for(var i in response.data){
                    var requestHandler=response.data[i];
                    requestHandlers[requestHandler.id]=requestHandler.name;
                }

                this.requestHandlers=requestHandlers;
            })

        },
        getProxies(){
            ProxyRepository.get().then((response) => {
                var proxies={null:'No proxy'};
                var data=response.data;
                for(var i in data){
                    proxies[data[i].id]=data[i].name;
                }
                this.proxies=proxies
            })

        },
        getJob(){
            var operations=[];
            for(var i=0;true;i++){
                var operation=this.$refs["operation_"+i];
                if(operation===undefined)
                    break;
                if(operation[0]===undefined)
                    continue;
                operation=operation[0].getOperation();
                
                operations.push(operation);
            }
            this.jobData.operations=operations;
            this.jobData.domain=this.$parent.domain.id;
        },
        setJob(jobData){
            this.jobData.id=jobData.id;
            this.jobData.operations=jobData.operations;
            this.$forceUpdate();

        },
       
        saveJob(){  
            this.modifyTagList()
            this.$emit('tag-list',this.tagList);

            if(this.showJob)
                this.getJob();
            
            if (this.jobData.id===null)
                JobRepository.post(this.jobData).then((response) => {
                    this.setJob(response.data);
                    this.$notify({
                        message: 'Job saved: '+this.jobData.name,
                        type: 'success',
                        size: 'lg',
                        timeout: 5000,
                        showClose: true
                    });
                });
            else
                JobRepository.put(this.jobData).then((response) => {
                    this.setJob(response.data);
                    this.$notify({
                        message: 'Job saved: '+this.jobData.name,
                        type: 'success',
                        size: 'lg',
                        timeout: 5000,
                        showClose: true
                    });
                });

        },
        deleteJob(){
            if(this.jobData.id!==null)
                JobRepository.delete(this.jobData.id);
            this.$parent.removeJob(this.jobData.id);
            this.showDeleteDialog=false;
        },
        startJob(){
            JobSchedulerRepository.run(this.jobData.id).then((response) => {
                this.$notify({
                    message: 'Job started successfully. Job log ID: '+response.data.job_log_id,
                    type: 'info',
                    size: 'lg',
                    timeout: 5000,
                    showClose: true
                });
            });
        },
        saveAndStartJob(){
            if(this.showJob)
                this.getJob();
            
            if (this.jobData.id===null)
                JobRepository.post(this.jobData).then((response) => {
                    this.setJob(response.data);
                    JobSchedulerRepository.run(this.jobData.id).then((response) => {
                        this.$notify({
                            message: 'Job saved and started successfully. Job log ID: '+response.data.job_log_id,
                            type: 'info',
                            size: 'lg',
                            timeout: 5000,
                            showClose: true
                        });
                    });
                });
            else
                JobRepository.put(this.jobData).then((response) => {
                    this.setJob(response.data);
                    JobSchedulerRepository.run(this.jobData.id).then((response) => {
                        this.$notify({
                            message: 'Job saved and started successfully. Job log ID: '+response.data.job_log_id,
                            type: 'info',
                            size: 'lg',
                            timeout: 5000,
                            showClose: true
                        });
                    });
                });
        },
        scheduleJob(){
            // TODO
        },
        addOperation(){
            var operation={
                id:null,
                is_merger_operation:true,
                name:this.jobData.name+'_operation_'+this.jobData.operations.length,
                parser:1,
                actions:[],
                request_handler:null, // kontrol
                use_proxies:false,
            }
            this.jobData.operations.push(operation);
            this.$forceUpdate();
            this.$nextTick().then(() => {
                window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight); // Sayfanın sonuna yani yeni eklenen operasyona scroll yapar
            })
        },
        deleteOperation(index){
            this.jobData.operations.splice(index,1)
            this.$forceUpdate();

        },
        changeOperationIndex(currentIndex,newIndex){
            if(newIndex<0)
                return;
            if(newIndex>=this.jobData.operations.length)
                return;
            
            if(currentIndex<0)
                return;
            if(currentIndex>=this.jobData.operations.length)
                return;
            
            var operation=this.jobData.operations[currentIndex];
            this.jobData.operations[currentIndex]=this.jobData.operations[newIndex];
            this.jobData.operations[newIndex]=operation;
            this.$forceUpdate(); // Bu olmazsa değişiklikler sayfada gözükmüyor.

            // this.$nextTick().then(() => {
            //     this.$refs['operation_'+currentIndex].scrollIntoView(true);
            // })

        },
        switchJob(){
            this.showJob=!(this.showJob);

        },
        exportJob(){
            
            var jobData=this.copyObject(this.jobData);
            delete jobData.id;
            delete jobData.domain;

            for(var i in jobData.operations)
                delete jobData.operations[i].id
            return JSON.stringify(jobData,null,4); // Indent ile çıktı vermesi için

        },
        importJob(){
            var jobData=JSON.parse(this.importData);
            if(this.jobData.id!==undefined)
                jobData.id=this.jobData.id
            if(this.jobData.domain!==undefined)
                jobData.domain=this.jobData.domain
            
            for(var i=0;i<jobData.operations.length;i++){
                var op=this.jobData.operations[i];
                var opId=op!==undefined ? op.id : null;
                jobData.operations[i].id=opId
            }
            this.jobData=jobData;
            this.importData='';
            this.$forceUpdate();
            this.showImportDialog=false;

        }
    }
}
</script>

<style>

.job-data {
    display:inline;
}

.job-domain {
    display:grid;
    grid-template-columns: 1fr 1fr;
    text-align: left;
    padding-left:2%;
}

.job-run-buttons {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    width: 25%;
    padding-left: 75%;
}

.operations-div {
    display: flex;
    flex-direction: column;
}

.operation-item {
    display: flex;
}

.card {
    margin: 1rem !important;
}
</style>